import { Component, ViewChild,ElementRef,HostListener} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { ActionSheetController,AlertController,LoadingController,ModalController } from '@ionic/angular';
import { NativeService } from '../../../../service/native.service';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { ModalpagePage } from '../../../modalpage/modalpage.page';
declare var app;
@Component({
  selector: 'app-a2-activity-center-detail',
  templateUrl: './a2-activity-center-detail.component.html',
  styleUrls: ['./a2-activity-center-detail.component.scss']
})
export class A2ActivityCenterDetailComponent extends GridBaseCase {
  @ViewChild('map') map_container:ElementRef;
  imgUrlArr = [];//门头照
  imgUrlSignInArr = [];//签到照片
  imgUrlSceneArr = [];//现场照片
  imgUrlActivityArr = [];//活动机制照片
  imgUrlOtherArr = [];//其他照片
  systemUserList:Array<any>= new Array<any>();
  object:any={};
  CustomInterfaceOptions: any = {
    header: '协助人',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  tabsIndex = 0;//选中tabs
  AssistingPeople = [];//协助人列表
  isBeginSevenDay:Boolean = false;//活动是否开始7天以前
  isendSevenDay:Boolean = false;//活动是否结束7天以内
  isFuzeren:Boolean = false;//是否是负责人
  isEnd:Boolean = false;//活动是否已结束
  signList = [];//签到人列表
  flag:any = null;//活动状态 1进行中 2未开始 0已结束
  locationerror:boolean = false;//定位失败备注，默认定位成功不显示
  locationIsLoading:boolean = false;//定位是否完成
  activityId:string = null;
  isShowSelect:boolean = true;
  isSubmitData:boolean = true;//是否可以提交数据
  isLeading:boolean = false;//是否是区域负责人、省区负责人

  huodongxiaolei:any = [];//活动小类
  changcileixing:any = [];//场次类型
  yaoyuequdao:any = [];//邀约渠道
  constructor(
    private map:MapclientServiceService,
    private nativeService:NativeService,
    private actionSheet: ActionSheetController,
    private modalController:ModalController,
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    public keyboard:Keyboard,
    public alertCtrl:AlertController,
    public loadingCtrl:LoadingController
  ) { super(); 
    let that = this;
    this.activityId = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    this.flag = parseInt(this.activaRouter.snapshot.paramMap.get('id').split("&")[1]);
    if(this.flag == 2){
      this.baseService.isbuttonvisble = false;
    }
    this.hideKeyboard();

    if(that.com.GetAccount.Roles){
      that.com.GetAccount.Roles.forEach(item=>{
        if(item.Code == "1007" || item.Code == "1008" || item.Code == "1009"){
          that.isLeading = true;
        }
      })
    }
  }

  
  /**
   * 获取定位
   */
  getLocation(isReGetLocation:boolean = false){
    const that = this;
    that.locationIsLoading = false;

    if(isReGetLocation){
      that.object.a_FeedbackStreetAddress="";
      that.object.a_Latitude = "";
      that.object.a_Longitude = "";
    }
    
    // if(that.platform.is("android") && that.platform.is("cordova")){
      if(that.platform.is("cordova")){
        that.map.getGDCurrentPosition().then(data=>{
          that.locationIsLoading = true;
          that.locationerror = false;
          that.object.a_FeedbackStreetAddress=that.com.GetChineselanage(data.address);
          that.object.a_Latitude = data.latitude;
          that.object.a_Longitude = data.longitude;
        }).catch(error=>{
          that.locationIsLoading = true;
          that.locationerror = true;
          console.log("定位失败,请联系管理员");
        });
      // that.map.getCurrentPosition().then(data=>{
      //   that.locationIsLoading = true;
      //   that.locationerror = false;
      //   that.object.a_FeedbackStreetAddress=that.com.GetChineselanage(data.address);
      //   that.object.a_Latitude = data.latitude;
      //   that.object.a_Longitude = data.longitude;
      // }).catch(error=>{
      //   that.locationIsLoading = true;
      //   that.locationerror = true;
      //   console.log("定位失败,请联系管理员");
      // });
    }else{
      that.map.Geolocation(that.map_container.nativeElement).then(data=>{
        // loads.dismiss();
        that.locationIsLoading = true;
        that.locationerror = false;
        that.object.a_FeedbackStreetAddress=that.com.GetChineselanage(data.formattedAddress);
        that.object.a_Latitude=data.position.lat;
        that.object.a_Longitude=data.position.lng;
      }).catch(error=>{
        that.locationerror = true;
        that.locationIsLoading = true;
        // loads.dismiss();
      });
    }
  }

  async presentModal() {
    let that = this;
    const modal = await this.modalController.create({
      component: ModalpagePage,
      componentProps: {
        "PageTitle":"选择协助人",
        "ConfigName": "SystemUser",
        "PageName":"ActivityCenterDetail",
        "Param":{"id":that.activityId,"a_PlannedPopulation":that.object.a_PlannedPopulation}
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if(data["modalStatus"]){
      that.AssistingPeople = data["info"];
      that.BindOutInfo();
    }
    console.log(data,"onWillDismiss");
  }

  changeSelect($event){
    let valArr = $event.detail.value;
    let that = this;
    if(that.object.a_PlannedPopulation && valArr.length > that.object.a_PlannedPopulation){
      that.isShowSelect = false;
      that.msg.Alert("添加的协助人数不能超过"+that.object.a_PlannedPopulation+"人");
      this.systemUserList.forEach((item,index)=>{
        item["isCheck"] = false;
        that.AssistingPeople.forEach((val,index)=>{
          if(item['a_ID'] == val["a_ID"]){
            item["isCheck"] = true;
          }
        });
      });
      //this.systemUserList.push({});
      // that.systemUserList.splice(5,1);
      setTimeout(()=>{
        that.isShowSelect = true;
      },500);//重新渲染select组件
      return;
    }
    // console.log(this.systemUserList,"this.systemUserList2222");
    that.AssistingPeople = [];
    this.systemUserList.forEach((item,index)=>{
      item["isCheck"] = false;
      valArr.forEach((val,index)=>{
        if(item['a_ID'] == val){
          if(JSON.stringify(that.AssistingPeople).indexOf(item['a_ID']) == -1){
            that.AssistingPeople.push({"a_ID":item['a_ID'],"name":item['a_ChineseName']});
          }
          item["isCheck"] = true;
        }
      });
    });
   
    that.BindOutInfo();
  }

  /**
   * 
   * @param e 
   * @param n 1 活动小类、2 场次类型、3 邀约渠道
   */
  changeActTypeSelect(e,n){
    let that = this;
    let val = e.detail.value;
    that.object[""] = val;
    switch(n){
      case 1:
          that.object["a_FK_TBActivityTypeChild_ID"] = val;
          break;
      case 2:
          that.object["a_FK_TBActivityPlaceType_ID"] = val;
          break;
      case 3:
          that.object["a_FK_TBActivityChannel_ID"] = val;
          break;
    }
  }

  /**
   * 获取活动小类、场次类型、邀约渠道
   */
  getActivityTypeList1(){
    const that =this;
    let _obj={};
    that.isShowSelect = false;
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.ConfigName = "TBActivityTypeChildXML";
    _obj["a_FK_TBActivityType_ID"]=that.object["a_FK_TBActivityType_ID"];
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = "PageName";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody=JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.huodongxiaolei = data.Status.Datas;
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
      setTimeout(()=>{
        that.isShowSelect = true;
      },1500);//重新渲染select组件
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
  }
  getActivityTypeList2(){
    const that =this;
    let _obj={};
    that.isShowSelect = false;
    let body = new WebParameterContext();
    body.ConfigName = "TBActivityPlaceTypeXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = "PageName";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.changcileixing = data.Status.Datas;
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
      setTimeout(()=>{
        that.isShowSelect = true;
      },500);//重新渲染select组件
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
  }
  getActivityTypeList3(){
    const that =this;
    let _obj={};
    that.isShowSelect = false;
    let body = new WebParameterContext();
    body.ConfigName = "TBActivityChannelXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = "PageName";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.yaoyuequdao = data.Status.Datas;
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
      setTimeout(()=>{
        that.isShowSelect = true;
      },500);//重新渲染select组件
    }).catch(error => {
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
  }
/**
 * 保存协助人
 */
  BindOutInfo(){
    const that =this;
    let _objArray:Array<any>=new Array<any>();
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "SystemUserActivityRelation";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if(that.AssistingPeople.length<=0){
       return;
    }
    that.AssistingPeople.forEach(item=>{
     let _obj={};
        _obj["a_FK_SystemUser_ID"]=item["a_ID"];
        _obj["a_FK_TBActivity_ID"]=id;
        _objArray.push(_obj);
    });
    body.RequestBody=JSON.stringify(_objArray);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        console.log(data.Status);
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
    });
  }
  /**
   * 拍照
   */
  getCamera(type){
    console.log(type);
    let that = this;
    // that.nativeService.getCameraPicture({saveToPhotoAlbum:true}).then((data)=>{
    //   let url = "data:image/jpeg;base64," + data;
    //   that.uploadImg(url,type,false,0);
    // })
    that.nativeService.getCameraPictureUrl({saveToPhotoAlbum: true,quality:app.activityquality||15}).then(fileUrl=>{
      that.uploadImg(fileUrl,type,false,0);
    })
  }

   /**
   * 上传图片
   * @param fileUrl 图片文件地址
   * @param type 活动现场照片
   * @param isReUpload 是否重新上传
   * @param index 哪张从新上传
   */
  uploadImg(fileUrl,type,isReUpload,index){
    let that = this;
    if(isReUpload){//重新上传获取图片base64 url
      switch (type) {
        case "a_DoorwayPicture"://门头照
        fileUrl = that.imgUrlArr[index]["url"];
          break;
        case "a_SignInPicture"://签到照
        fileUrl = that.imgUrlSignInArr[index]["url"];
          break;
        case "a_ScenePicture"://现场照片
        fileUrl = that.imgUrlSceneArr[index]["url"];
          break;
        case "a_ActivityMechanismPicture"://活动机制照片
        fileUrl = that.imgUrlActivityArr[index]["url"];
          break;
        case "a_OtherPicture"://其他照片
        fileUrl = that.imgUrlOtherArr[index]["url"];
          break;
      }
    }


    let FILE_URI = fileUrl;
    let transfer = new FileTransfer();
    console.log(FILE_URI,"FILE_URI");
    const fileTransfer: FileTransferObject = transfer.create();
    let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: that.nativeService.GetImgFileName()+".jpg",
      // mimeType: "image/jpeg",
      httpMethod: "post",
      headers:null
    };
    let _msg = "已上传"
    that.msg.Loading(_msg).then(load=>{
      fileTransfer.upload(FILE_URI,app.UPLOADURL,options).then(data=>{
        load.dismiss();
        if(data.responseCode == 200){
          let message = JSON.parse(data.response);
          console.log(message,"res");
          if(message.ResponseMessage.Success && message.Status.length > 0){
            let _imgName = message.Status[0].FileName;
            let _url = app.FileUoloadUrl+_imgName.trim().replace(app.ImagePlaceholder,app.SmallImageType);
            // item.url.trim().replace(app.SmallImageType,app.BigImageType);
            let _obj = { url: _url, name: _imgName, isUpload: true };
            that.ProcessingUploadData(type,isReUpload,index,_obj);
            
          }else{
            that.msg.Alert("上传失败,请检查网络！");
            let _obj = { url: FILE_URI, name: null, isUpload: false };
            that.ProcessingUploadData(type,isReUpload,index,_obj);
          }
        }
      }).catch(error=>{
        load.dismiss();
        console.log(error);
        that.msg.Alert("上传失败,请检查网络！");
        let _obj = { url: FILE_URI, name: null, isUpload: false };
        that.ProcessingUploadData(type,isReUpload,index,_obj);
      });
      fileTransfer.onProgress(( event: ProgressEvent ) => {
        let num = Math.floor( event.loaded / event.total * 100 );
        console.log(num,"百分比")
        if ( num === 100 ) {
          load.message = '上传完成';
          load.dismiss();
        } else{
          let title = num;
          title && ( load.message = _msg + num + '%' );
        }
      });
      load.present();
    })

    
    // that.msg.Loading("上传中，请稍后...").then(load=>{
    //   that.nativeService.AsyncCompressAccurately(fileUrl, 1, 300,2).then((body) => {
    //     load.dismiss();
    //     let imgName = body.Status[0].FileName;
    //     let _obj = { url: fileUrl, name: imgName, isUpload: true};
    //     that.ProcessingUploadData(type,isReUpload,index,_obj);
    //     // localStorage.setItem("activity_" + name, JSON.stringify(that.imgUrlArr));
    //   }).catch(error=>{
    //     load.dismiss();
    //     console.log(error);
    //     that.msg.Alert("上传失败，请检查网络!");
    //     let _obj = { url: fileUrl, name: null, isUpload: false };
    //     that.ProcessingUploadData(type,isReUpload,index,_obj);
    //     // localStorage.setItem("activity_" + name, JSON.stringify(that.imgUrlArr));
    //   })
    //   load.present();
     
    // })
  }

  /**
   * 重新上传
   * @param index 第几张照片
   * @param type 类型：活动现场照片
   */
  reUpload(index,type){
    this.uploadImg("",type,true,index);
  }

  /**
   * 处理上传结果
   * @param type 活动现场照片
   * @param isReUpload 是否重新上传
   * @param index 哪张从新上传
   * @param _obj 图片数据
   */
  ProcessingUploadData(type,isReUpload,index,_obj){
    let that = this;
    if(isReUpload){
      switch (type) {
        case "a_DoorwayPicture"://门头照
          that.imgUrlArr[index] = _obj;
          break;
        case "a_SignInPicture"://签到照
          that.imgUrlSignInArr[index] = _obj;
          break;
        case "a_ScenePicture"://现场照片
          that.imgUrlSceneArr[index] = _obj;
          break;
        case "a_ActivityMechanismPicture"://活动机制照片
          that.imgUrlActivityArr[index] = _obj;
          break;
        case "a_OtherPicture"://其他照片
          that.imgUrlOtherArr[index] = _obj;
          break;
      }
    }else{
      switch (type) {
        case "a_DoorwayPicture"://门头照
          that.imgUrlArr.push(_obj);
          break;
        case "a_SignInPicture"://签到照
          that.imgUrlSignInArr.push(_obj);
          break;
        case "a_ScenePicture"://现场照片
          that.imgUrlSceneArr.push(_obj);
          break;
        case "a_ActivityMechanismPicture"://活动机制照片
          that.imgUrlActivityArr.push(_obj);
          break;
        case "a_OtherPicture"://其他照片
          that.imgUrlOtherArr.push(_obj);
          break;
      }
    }
  }

  LoadData(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    // console.log("12121221");
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    that.BindUser();
    
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody=JSON.stringify({"a_ID":id,"flag":that.flag});
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        console.log("定位信息");
        that.object = data.Status.Datas[0];
        that.getActivityTypeList1();
        that.getActivityTypeList2();
        that.getActivityTypeList3();
        const u_ID = that.object["u_ID"] || null;
        if(that.object["a_StartTime"]){
          that.object["startTime"] = that.object["a_StartTime"].replace(" ","T");
        }
        if(that.object["a_EndTime"]){
          that.object["endTime"] = that.object["a_EndTime"].replace(" ","T");
        }

        that.isFuzeren = u_ID == that.com.GetAccount.Id;
        if(that.flag==1 && that.isFuzeren){
          if(!that.object.a_FeedbackStreetAddress){
            that.getLocation();//获取定位
          };
          }
            that.isBeginSevenDay = that.DateComparison(that.object["a_StartTime"]);
            that.isEnd = that.DateComparison2(that.object["a_EndTime"]);
            that.isendSevenDay = that.DateComparisonEnd(that.object["a_EndTime"]);
              if(that.object){
                if(that.object["a_DoorwayPicture"]){//门头照
                  that.imgUrlArr = (that.getCameraList("a_DoorwayPicture", that.object["a_DoorwayPicture"]));
                }
                if(that.object["a_SignInPicture"]){//签到照
                  that.imgUrlSignInArr = (that.getCameraList("a_SignInPicture", that.object["a_SignInPicture"]));
                }
                if(that.object["a_ScenePicture"]){//现场照片
                  that.imgUrlSceneArr = (that.getCameraList("a_ScenePicture", that.object["a_ScenePicture"]));
                }
                if(that.object["a_ActivityMechanismPicture"]){//活动机制照片
                  that.imgUrlActivityArr = (that.getCameraList("a_ActivityMechanismPicture", that.object["a_ActivityMechanismPicture"]));
                }
                if(that.object["a_OtherPicture"]){//其他照片
                  that.imgUrlOtherArr = (that.getCameraList("a_OtherPicture", that.object["a_OtherPicture"]));
                }
              }
            // let imgUrl = that.object["a_ActivityPhotos"];//活动照片
           
            // let _activityImg = localStorage.getItem("activity_"+that.activityId);
            // if(_activityImg){
            //   that.imgUrlArr = JSON.parse(_activityImg);
            // }else{
            //   if(imgUrl){
            //     let arr = imgUrl.split(",");
            //     arr.forEach(item=>{
            //       let _obj = {
            //         url:(app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType),
            //         name:item
            //       };
            //       that.imgUrlArr.push(_obj);
            //     })
            //   }
            // }
        
        //是负责人，获取已签到列表
        // if(that.isFuzeren){
        //   that.getSignPerson();
        // }
      //  that.productArrayList=data.Status.Datas;
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      console.log(error);
    });

  }
  EventChanage(event){
    setTimeout(()=>{
      if(event.target.value){
        let numvalue:any= this.com.GetNumber(event.target.value);
       if(numvalue){
        this.object.a_PlannedPopulation = numvalue;
         event.target.value = numvalue;
       }else{
        this.object.a_PlannedPopulation = 0;
         event.target.value=null;
       }
     }else{
         this.object.a_PlannedPopulation = 0;
         event.target.value=null;
     }
    },400);
  }
getCameraList(picture,obj){
  const that = this;
  let tempArray:Array<any> = new Array<any>();
  let imgUrl = obj;
  let _activityImg = localStorage.getItem("activity_"+picture);
  if(_activityImg){
    tempArray = JSON.parse(_activityImg);
  }else{
    if(imgUrl){
      let arr = imgUrl.split(",");
      arr.forEach(item=>{
        let _obj = {
          url:(app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType),
          name:item
        };
        tempArray.push(_obj);
      });
    }
  }
  return tempArray;

}

  async EditImg(i,picture) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.imgPreview(i,picture);
      return;
    }
    let _option:any = {};
    let _option1 = {
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          console.log('预览');
          that.imgPreview(i,picture);
        }
      }, {
        text: '删除',
        handler: () => {
          if(that[picture]){
            that[picture].splice(i, 1);
          }
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    };
    let _option2 = {
      // header: '',
      buttons: [{
        text: '删除',
        handler: () => {
          if(that[picture]){
            that[picture].splice(i, 1);
          }
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    }
    let _isUpload = that[picture][i]["isUpload"];
    let _url = that[picture][i]["url"];
    if(_isUpload || _url.indexOf("http") > -1){
      _option = _option1;
    }else{
      _option = _option2;
    }
    const actionSheet = await this.actionSheet.create(_option);
    await actionSheet.present();
  }
  imgPreview(i,picture){
    let that = this;
    let url = [];
    if(that[picture]){
      that[picture].forEach(item=>{
        let u = null;
        if(item.url.indexOf("data:") > -1){
          u = item.url
        }else{
          u = item.url.trim().replace(app.SmallImageType, app.BigImageType);
        }
        url.push(u);
      });
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl();
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{ImgPreview: JSON.stringify(ImgPreview)});
      // that.router.navigate(["/tabs/contact/ImgPreview/"+that.com.getNowDatetime], {
      //   queryParams: {
      //     ImgPreview: JSON.stringify(ImgPreview)
      //   }
      // });
    }
  
   
  }

/**
 * 已邀请协助人
 */
  getSystemUserList(){
    const that =this;
    let _obj={};
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "SystemUserActivityRelation";
    _obj["a_FK_TBActivity_ID"]=id;
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = app.RowsPerPage; 
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody=JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.AssistingPeople=[];
        that.systemUserList.forEach((item,index)=>{
          item["isCheck"] = false;
          data.Status.Datas.forEach(val=>{
            if(item['a_ID'] == val["bs_ID"]){
              if(JSON.stringify(that.AssistingPeople).indexOf(item['a_ID']) == -1){
                that.AssistingPeople.push({"a_ID":item['a_ID'],"name":item['a_ChineseName']});
              }
              item["isCheck"] = true;
            }
          });
        });
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
    });

  }
  /**
   * 获取所有协助人
   */
  BindUser(){
    const that =this;
    let _obj={};
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "SystemUser";
    _obj["uar_OpType"]="ADD";
    _obj["a_FK_TBActivity_ID"]=id;
    _obj["u_ID"]=that.com.GetAccount.Id;
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = 100;
    // body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody=JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.systemUserList = data.Status.Datas;
        this.getSystemUserList();//已邀请人
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
    });
  }
/**
 * 提交数据
 */
  EventClick(i:number){
    const that =this;
    if(!that.isSubmitData){
      return;
    }else{
      that.isSubmitData = false;
    }

    let isHaveUploadError = false;
    that.imgUrlArr.forEach(item => {//门头照片
      if (!item["isUpload"] && item["url"].indexOf("http") == -1) {
        isHaveUploadError = true;
      }
    })
    that.imgUrlSignInArr.forEach(item => {//签到照片
      if (!item["isUpload"] && item["url"].indexOf("http") == -1) {
        isHaveUploadError = true;
      }
    })
    that.imgUrlSceneArr.forEach(item => {//现场照片
      if (!item["isUpload"] && item["url"].indexOf("http") == -1) {
        isHaveUploadError = true;
      }
    })
    that.imgUrlActivityArr.forEach(item => {//活动机制照片
      if (!item["isUpload"] && item["url"].indexOf("http") == -1) {
        isHaveUploadError = true;
      }
    })
    that.imgUrlOtherArr.forEach(item => {//其他照片
      if (!item["isUpload"] && item["url"].indexOf("http") == -1) {
        isHaveUploadError = true;
      }
    })

    if(isHaveUploadError){
      that.msg.Alert("您有未上传成功的照片，请先上传或删除后再保存！");
      that.isSubmitData = true;
      return;
    }

    if(Object.keys(that.object).length==0){
      that.msg.Alert("请填写活动反馈");
      that.isSubmitData = true;
      return;
    }

    let _obj={};
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      that.isSubmitData = true;
      return;
    }
    body.ConfigName = "TBActivity";
    _obj["a_ID"]=id;
    if(that.object.a_Name){//活动名称
      _obj["a_Name"]=that.object.a_Name;
    }
    if(that.object.a_StartTime){//活动开始时间
      _obj["a_StartTime"]=that.object.a_StartTime.replace("T"," ");
    }
    if(that.object.a_EndTime){//活动结束时间
      _obj["a_EndTime"]=that.object.a_EndTime.replace("T"," ");
    }
    if(that.object.a_PlaceName){//活动场所
      _obj["a_PlaceName"]=that.object.a_PlaceName;
    }
    if(that.object.a_Context){//活动内容
      _obj["a_Context"]=that.object.a_Context;
    }
    if(that.object.a_Address){//活动地址
      _obj["a_Address"]=that.object.a_Address;
    }
    if(that.object.a_FeedbackContent){
      _obj["a_FeedbackContent"]=that.object.a_FeedbackContent;
    }
  if(that.object.a_Latitude){
    _obj["a_Latitude"]=that.object.a_Latitude;
  }
  if(that.object.a_Longitude){
    _obj["a_Longitude"]=that.object.a_Longitude;
  }
  if(that.object.a_FeedbackStreetAddress){
    _obj["a_FeedbackStreetAddress"]=that.com.GetChineselanage(that.object.a_FeedbackStreetAddress);
  }
  if(that.object.a_BrightSpot){
    _obj["a_BrightSpot"]=that.object.a_BrightSpot;
  }
  if(that.object.a_Improved){
    _obj["a_Improved"]=that.object.a_Improved;
  }
  if(that.object.a_Summary){
    _obj["a_Summary"]=that.object.a_Summary;
  }
  if(that.object.a_Remarks){
    _obj["a_Remarks"]=that.object.a_Remarks;
  }
  if(that.object.a_PlannedPopulation){//预计邀约人数
    _obj["a_PlannedPopulation"]=that.object.a_PlannedPopulation;
  }
  if(that.object.a_ActivityMechanism){//活动机制
    _obj["a_ActivityMechanism"]=that.object.a_ActivityMechanism;
  }
  if(that.object.a_ActivityMechanism){//活动机制
    _obj["a_ActivityMechanism"]=that.object.a_ActivityMechanism;
  }
    if(that.imgUrlArr.length>0){//门头照
      _obj["a_DoorwayPicture"]=that.getPictureobj(that.imgUrlArr);
    }
    if(that.imgUrlSignInArr.length>0){//签到照
      _obj["a_SignInPicture"]=that.getPictureobj(that.imgUrlSignInArr);
    }
    if(that.imgUrlSceneArr.length>0){//现场照片
      _obj["a_ScenePicture"]=that.getPictureobj(that.imgUrlSceneArr);
    }
    if(that.imgUrlActivityArr.length>0){//活动机制照片
      _obj["a_ActivityMechanismPicture"]=that.getPictureobj(that.imgUrlActivityArr);
    }
    if(that.imgUrlOtherArr.length>0){//其他照片
      _obj["a_OtherPicture"]=that.getPictureobj(that.imgUrlOtherArr);
    }
    if(that.object.a_FK_TBActivityTypeChild_ID){//活动小类
      _obj["a_FK_TBActivityTypeChild_ID"]=that.object.a_FK_TBActivityTypeChild_ID;
    }
    if(that.object.a_FK_TBActivityPlaceType_ID){//场次类型
      _obj["a_FK_TBActivityPlaceType_ID"]=that.object.a_FK_TBActivityPlaceType_ID;
    }

    if(that.object.a_FK_TBActivityChannel_ID){//渠道类型
      _obj["a_FK_TBActivityChannel_ID"]=that.object.a_FK_TBActivityChannel_ID;
    }

    let d1 = new Date(this.object.a_StartTime.replace(/-/g,"/")).getTime();
    let d2 = new Date(this.object.a_EndTime.replace(/-/g,"/")).getTime();
    if(d1 >= d2){
      this.msg.Alert("开始日期不得大于或等于结束日期！");
      that.isSubmitData = true;
      return;
    }
  
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody=JSON.stringify(_obj);
    
    that.saveDate(body);

  }
  
  /**
   * 保存数据
   */
  saveDate(body){
    const that = this;
    that.msg.Confirm("是否保存？").then(data=>{
      if(data){
        that.http.post(app.DEFAULTURL, body).then(data => {
          that.isSubmitData = true;
          if (data.ResponseMessage.Success) {
            localStorage.removeItem("activity_a_DoorwayPicture");
            localStorage.removeItem("activity_a_SignInPicture");
            localStorage.removeItem("activity_a_ScenePicture");
            localStorage.removeItem("activity_a_ActivityMechanismPicture");
            localStorage.removeItem("activity_a_OtherPicture");
             that.msg.Alert("提交数据成功").then(fail=>{
              if(fail){
                that.com.goBack();
              }
             });
          }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          that.isSubmitData = true;
          console.log(error);
        });
      }else{
        that.isSubmitData = true;
      }
    })
  }

/**
 * 判断是否多张照片
 * @param arrayObj 
 */
  getPictureobj(arrayObj:Array<any>){
   const that =this;
   let reustl = "";
   if(arrayObj.length>0){
    let imgName = null;
    arrayObj.forEach(item=>{
      if(item.name){
        if(imgName){
          imgName +=','+item.name;
        }else{
          imgName = item.name;
        }
      }
    });
    reustl=imgName;
   }
   return reustl;
  }

  /**
   * 
   * @param date1 活动开始日期
   */
  DateComparison(date){
    let _now = new Date();
    const _y = _now.getFullYear();
    const _m = _now.getMonth() + 1;
    let _d = _now.getDate();
    if(app.activityChangeBeginDate){
      _d = _d - app.activityChangeBeginDate;
    }
    let nowDate = new Date(_y+"/"+_m+"/"+_d+" 23:59:59").getTime();
    let actDate = new Date(date.replace(/-/g,"/")).getTime();
    return nowDate < actDate;
  }

  /**
   * 
   * @param date1 活动结束日期 已结束为true
   */
  DateComparison2(date){
    let nowDate = new Date().getTime();
    let actDate = new Date(date.replace(/-/g,"/")).getTime();
    return nowDate > actDate;
  }
   /**
   * 
   * @param date1 活动结束后3天之内 3天之外为true
   * 新增，结束后7天之内，不跨月
   */
  DateComparisonEnd(date){
    console.log(date);
    console.log(this.flag);
    // let _now = new Date();
    // const _y = _now.getFullYear();
    // const _m = _now.getMonth() + 1;
    // const _d = _now.getDate();
    // let nowDate = new Date(_y+"/"+_m+"/"+_d+" 23:59:59").getTime();


    let nowDate = new Date().getTime();//当前日期  
    let actYear = new Date(date.replace(/-/g,"/")).getFullYear();
    let actMonth = new Date(date.replace(/-/g,"/")).getMonth() + 1;
    let actDay = new Date(date.replace(/-/g,"/")).getDate();
    let actMonthDays = new Date(actYear,actMonth,0).getDate();
    let comparisonDays = app.activityChangeEndDate;//结束7天之内，不跨月
    if((actMonthDays-actDay)<7){
      comparisonDays = actMonthDays-actDay;
    }
    let actDate = new Date(date.replace(/-/g,"/")).getTime()+ comparisonDays * 24 * 60 * 60 * 1000;//结束日期
    return actDate > nowDate;
  }

  /**
   * 
   * @param num 选中
   */
  tabsEvent(num){
    const that =this;
    if(num==1){
      if(!that.object.a_Address && !that.object.a_BrightSpot && that.imgUrlArr.length<=0){
        that.msg.Alert("请先完成活动反馈");
        return;
      }
    }
    this.tabsIndex = num;
  }

  /**
   * 获取签到人
   */
  getSignPerson(){
    const that =this;
    let _obj={};
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBMemberSign";
    _obj["FK_TBActivity_ID"]=id;
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody=JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.AssistingPeople=[];
        that.systemUserList.forEach((item,index)=>{
          item["isCheck"] = false;
          that.signList = data.Status.Datas;
        });
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
    });

  }

  /**
   * 
   * @param $event event
   * @param n 0 开始时间；1结束时间
   */
  DateChange($event,n){
    console.log($event);
    let date = $event.detail.value;
    date = date.replace("T"," ").replace("Z","").replace("-00:00","");
    if(n == 0){
      this.object.a_StartTime = date;
    }else{
      this.object.a_EndTime = date;
    }
    let d1 = new Date(this.object.a_StartTime.replace(/-/g,"/")).getTime();
    let d2 = new Date(this.object.a_EndTime.replace(/-/g,"/")).getTime();
    if(d1 >= d2){
      this.msg.Alert("开始日期不得大于或等于结束日期！");
    }
    console.log(date,"---------date--------",this.object.startTime,this.object.endTime);
  }

  /**
  * 签到地址二维码
  * 
  */
 orderQRCode(url){
  this.com.setHistoryUrl();
  this.com.goQrCode(url, 'activityCode',"扫码签到");
 }

//  扫码销量

 salesQRCode(){
   this.com.setHistoryUrl();
   this.com.Go("/tabs/contact/ScanCodeSales/add/"+this.activityId+"&mmbActivity&"+this.com.getNowDatetime);
  //  this.router.navigate(["/tabs/contact/ScanCodeSales/add/"+this.activityId+"&mmbActivity&"+this.com.getNowDatetime]);
 }

   /**
   * 获取焦点、失去焦点
   * @param event 事件
   * @param inputType 输入类型
   */
  focusOrBlurEvent(event, inputType) {
    if (this.platform.is("android")) {
      const directiveClass: any = document.getElementsByClassName("ActivityCenterDetailDirectiveClass");
      let directiveClassDom: any = null;
      if (directiveClass && directiveClass.length > 0) {
        directiveClassDom = directiveClass[directiveClass.length - 1];
      } else {
        return;
      }
      if (event && event.type == "ionFocus") {
        directiveClassDom.style.paddingBottom = "200px";
      } else if (event && event.type == 'ionBlur') {
        directiveClassDom.style.paddingBottom = "0";
      }
    }
  }
  hideKeyboard() {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    if (PageName != 'ActivityCenterDetail') { return; }
    if (that.platform.is("android")) {
      that.keyboard.onKeyboardHide().subscribe((data) => {
        const directiveClass: any = document.getElementsByClassName("ActivityCenterDetailDirectiveClass");
        if (directiveClass && directiveClass.length > 0) {
          directiveClass[directiveClass.length - 1].style.paddingBottom = "0";
        }
      })
    }
  }

  // @HostListener('document:ionBackButton', ['$event'])
  // private overrideHardwareBackAction($event: any) {
  //   const that = this;
  //   //  console.log("监听事件...");
  //   $event.detail.register(100, async () => {
  //     // console.log("返回按钮...");
  //     that.androidBackButtonHandle();
  //     return;
  //   });
  // }

    /**
   * 返回上一页处理逻辑
   */
  async androidBackButtonHandle(){
    const that= this;
    try{
      // that.keyboard.hide();//键盘事件
      const loading  =await that.loadingCtrl.getTop();
      if(loading){
        // loading.dismiss();
        return;
      }
      const alert = await that.alertCtrl.getTop();
      if(alert){
        alert.dismiss();
        return;
      }
      that.com.goBack();
    }catch(error){

    }
  }
  
}
